<div class="activity-report-wrapper">
	<header class="activity-report-header">
		<h1 class="activity-report-title">
			{{ 'activity-report_header-title' | translate }}
		</h1>
		<ngx-overview-navigation></ngx-overview-navigation>
	</header>

	@if(activityId !== null && groupId !== null) {
		<div class="activity-report-scroll">
			<activity-report
				[activityId]="activityId"
				[groupId]="groupId"
				class="activity-report-content">
			</activity-report>
		</div>
	}
</div>
